import styled from 'styled-components'

export const MenuSpan = styled.span`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  height: 100%;
  margin: 0 5px;
  transition-duration: 150ms;
  color: ${({theme}) => theme.colors.textThird};
  fill: currentColor;

  &:hover {
    text-decoration: none;
    cursor: pointer;
    color: ${({theme}) => theme.colors.textFourth};
    fill: currentColor;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${({theme}) => theme.colors.textFourth};
    opacity: 0;
    transition-duration: 0.25s;
    transform: translateY(100%);
  }

  &.active {
    &:after {
      opacity: 1;
      transform: translateY(0);
    }
    color: ${({theme}) => theme.colors.textFourth};
    fill: ${({theme}) => theme.colors.textFourth};
  }
  ${({$isActive, theme}) =>
    $isActive && {
      color: theme.colors.textFourth,
      fill: theme.colors.textFourth,
      '&:after': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    }}

  margin-right: 15px;
  margin-left: 0;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.textThird};
  fill: currentColor;

  svg {
    margin-right: 7px;
    /* max-width: 16px; */
  }

  .expand-icon {
    height: 20px;
    width: 20px;
    fill: currentColor;
    transition: transform 0.3s ease-out;
    ${({active}) =>
      active && {
        transform: 'rotate(180deg)',
      }}
  }
`
